module.exports = __webpack_public_path__ + "static/media/demo.71e953c9.png";